import React from 'react';
import clsx from 'clsx';

interface DropdownProps {
  children: React.ReactNode;
  arrow?: boolean;
  bgColor?: string;
  onMouseLeave?: () => void;
  isOpen?: boolean;
  ariaLabel?: string;
  className?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({
  children,
  bgColor,
  arrow = false,
  onMouseLeave,
  isOpen = true,
  ariaLabel,
  className
}) => (
  <div
    className={clsx(
      "absolute left-0 min-w-[180px] shadow-lg rounded-md z-40",
      arrow && "mt-2",
      !isOpen && "hidden",
      bgColor,
      className
    )}
    onMouseLeave={onMouseLeave}
    aria-label={ariaLabel}
  >
    {arrow && (
      <div className="absolute -top-2 left-4 w-4 h-4 overflow-hidden">
        <div
          className={clsx(
            "absolute top-[3px] left-1 w-2.5 h-2.5 rotate-45",
            bgColor
          )} />
      </div>
    )}
    {children}
  </div>
);